module.exports = __webpack_public_path__ + "img/qbert_questions_rear.cdb76755.jpg";